import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { MetaPixel } from './components/MetaPixel';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-brand-main font-sans text-brand-text selection:bg-brand-orange/25" data-id="element-0" data-mp="23t8hsfvmildz">
      <MetaPixel data-id="element-1" data-mp="3ii4ro0w5cqo1" />
      <CountdownBar data-id="element-2" data-mp="3mlaxx8j9ehui" />
      <main data-id="element-3" data-mp="3mkrcviybbdc9">
        <HeroSection data-id="element-4" data-mp="3mk85uxa7a9d0" />
        <StatsBar data-id="element-5" data-mp="3mjq3rk0ux0x6" />
        <TransformationSection data-id="element-6" data-mp="3mj6jhwnqi0fz" />
        <PainPointsSection data-id="element-7" data-mp="3rbzmog3k10py" />
        <KitContentsSection data-id="element-8" data-mp="3rcsy3udgkeef" />
        <InstantAccessSection data-id="element-9" data-mp="3relumgucxi8p" />
        <BonusesSection data-id="element-10" data-mp="6hovayao7c0" />
        <PricingSection data-id="element-11" data-mp="4n53zyrel9i" />
        <GuaranteeSection data-id="element-12" data-mp="56qxrrj5tst" />
        <TestimonialsSection data-id="element-13" data-mp="2zl3cxocsjc6w" />
        <FAQSection data-id="element-14" data-mp="2zm4y4lnitf2c" />
        <FinalCTASection data-id="element-15" data-mp="2zmo4d53t6f0j" />
      </main>
      <Footer data-id="element-16" data-mp="33mouvo46mgny" />
    </div>;
}